export var REVIEW_STATUS;
(function (REVIEW_STATUS) {
    REVIEW_STATUS["APPROVED"] = "APPROVED";
    REVIEW_STATUS["REJECTED"] = "REJECTED";
    REVIEW_STATUS["IN_REVIEW"] = "IN_REVIEW";
})(REVIEW_STATUS || (REVIEW_STATUS = {}));
//# sourceMappingURL=Underwriting.js.map